module.exports = __webpack_public_path__ + "static/hotspots-9ebf543a3d0633c705215cbafc243d8b.svg";